import actions from "./actions";
import uniq from "lodash/uniq.js";

const initState = {
  isLoading: false,
  errorMessage: false,
  itemsInView: [],
  chatTasksVisible: true,
  activeAgent: {
    agentId: "ai-line-assistant",
  },
};

/**
 * @summary Reducer for ai stream
 * @param {object} state
 * @param {object} data
 * @param {string} data.type
 * @param {{chatId:string,chat:models.Chat.Data,path:string,collectionPath:string}} data.stream
 * @return {*}
 */
export default function reducer(
  state =
    initState, {
    type,
    agentId,
    stream,
    streamDone,
    draftPath,
    path,
    payload,
    serviceId,
    activeAgent,
    activeIndex,
  }) {
  switch (type) {
    case actions.SET_AGENT: {
      return {
        ...state,
        activeAgent: {
          // ...state.activeAgent || null,
          ...activeAgent,
        },
      };
    }
    case actions.AI_WRITE_STREAM: {
      // if (!stream.collectionPath) {
      //   return state;
      // }
      return {
        ...state,
        [agentId]: {
          ...state[agentId] || null,
          // [stream.collectionPath]: [{
          //   ...stream.chat,
          //   answers: [
          //     ...stream.chat.answers.map((answer) => ({...answer}))
          //   ].filter(Boolean)},
          //   stream.path,
          //   streamDone,
          //   stream.collectionPath,
          // ],
          chat: [{
            ...stream.chat,
            answers: [
              ...stream.chat.answers.map((answer) => ({...answer}))
            ].filter(Boolean)},
            stream.path,
            streamDone,
            stream.collectionPath,
          ],
        }
      };
    }
    case actions.AI_CLEAR_STREAM:
      return {};
    case actions.SET_ACTIVE_EMAIL_DRAFT:
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          draft: {
            draftPath,
            collapse: true,
          },
        },
        // draft: {
        //   draftPath,
        //   collapse: true,
        // },
      };
    case actions.CLEAR_ACTIVE_EMAIL_DRAFT: {
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          draft: null,
        }
      };
    }
    case actions.SET_ACTIVE_USER_TASK: {
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          userTask: {
            path,
          },
        },
      };
    }
    case actions.CLEAR_ACTIVE_USER_TASK: {
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          userTask: null,
        }
      };
    }
    case actions.SET_ACTIVE_APP: {
      // console.log('SET_ACTIVE_APP', serviceId, path);
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          activeApp: {
            path,
          },
        },
      };
    }
    case actions.SET_ACTIVE_ACTION_INDEX: {
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          activeIndex,
          // activeActionPaths: uniq([...state[serviceId]?.activeActionPaths || [], path]),
        }
      };
    }
    case actions.CLEAR_ACTIVE_ACTION_INDEX: {
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          activeIndex: null,
          // activeActionPaths: path === null ?
          //   [] :
          //   (state[serviceId]?.activeActionPaths || [])
          //   .filter((path) => path !== path),
        }
      };
    }
    case actions.CLEAR_ACTIVE_APP: {
      return {
        ...state,
        [serviceId]: {
          ...state[serviceId] || null,
          activeApp: null,
        }
      };
    }
    case actions.LOG_ITEM_VISIBILITY: {
      return {
        ...state,
        itemsInView: payload.inView ?
          uniq(payload.fromBottom ?
            [...state.itemsInView, payload.path] :
            [payload.path, ...state.itemsInView],
          ) :
          state.itemsInView.filter((itemPath) => itemPath !== payload.path),
      };
    }
    case actions.TOGGLE_CHAT_TASKS_VISIBILE: {
      return {
        ...state,
        chatTasksVisible: !state.chatTasksVisible,
      };
    }
    default:
      return state;
  }
}
